import { render } from "./Supply.vue?vue&type=template&id=d6f4f49c&scoped=true"
import script from "./Supply.vue?vue&type=script&lang=js"
export * from "./Supply.vue?vue&type=script&lang=js"

import "./Supply.vue?vue&type=style&index=0&id=d6f4f49c&lang=scss&scoped=true"

import exportComponent from "/builds/optelgroup/exploration/reusable-components/supply-chain-simulator/prototype/iscp-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6f4f49c"]])

export default __exports__